//axios api
import api from "@/lib/Api";
import moment from "moment";

export const getProductInvoice = async (workLocationId, startDate, endDate) => {
  try {
    const queryRoute = `/product/getProductInvoice/0`;

    const reqBody = {
      type: "website",
      workLocationId: workLocationId ? workLocationId : null,
      startDate: startDate ? startDate : null,
      endDate: endDate ? endDate : null,
    };

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
export const getProductInvoiceByUserIdAndDate = async (
  user_id,
  location_id,
  date,
) => {
  try {
    const queryRoute = `/product/getProductInvoiceByUserIdAndDate?location_id=${location_id}&date=${date}&user_id=${user_id}`;

    const fetchRes = api.axios.get(queryRoute);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const exportToCsvByDate = async (start_date, selectedRegion) => {
  try {
    const queryRoute = `/product/exportToCsvByDate`;

    const reqBody = {
      start_date,
      region: selectedRegion,
    };

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
export const exportToXls = async (
  start_date,
  selectedRegion,
  template = false,
) => {
  try {
    const queryRoute = `/product/exportToXls`;

    const reqBody = {
      start_date,
      region: selectedRegion,
      template,
    };

    const fetchRes = api.axios.post(queryRoute, reqBody, {
      responseType: "blob",
    });

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getDiscount = async () => {
  try {
    const queryRoute = `/product/getDiscount`;

    const fetchRes = api.axios.post(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const createDiscount = async (discount_name, discount_percent) => {
  try {
    const queryRoute = `/product/createDiscount`;

    const reqBody = {
      discount_name,
      discount_percent,
    };

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const updateInvoceWorkLocation = async (location_id, invoices) => {
  try {
    const queryRoute = `/product/updateInvoceWorkLocation`;

    const reqBody = {
      location_id,
      invoices,
    };
    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.error(err.message);
    throw err;
  }
};
export const exportSalesSummary = async (startDate, endDate) => {
  try {
    const queryRoute = `/product/exportSalesSummary`;

    const reqBody = {
      startDate: startDate ? startDate : null,
      endDate: endDate ? endDate : null,
    };

    const fetchRes = await api.axios.post(queryRoute, reqBody, {
      responseType: "blob",
    });
    console.log("fetchRes", fetchRes);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

//create  a api call to retrieve details of all existing products from table 'product_master'
export const getProducts = async (getDeactive = true) => {
  try {
    const queryRoute = `/product/getProducts`;

    const body = {
      getDeactive,
    };

    const fetchRes = api.axios.post(queryRoute, body);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getManningsProducts = async (getDeactive = true) => {
  try {
    const queryRoute = `/product/getManningsProducts`;

    const body = {
      getDeactive,
    };

    const fetchRes = api.axios.post(queryRoute, body);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
export const getProductCategories = async () => {
  try {
    const queryRoute = `/product/getProducts/categories`;

    const fetchRes = api.axios.get(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

//create a api call to retrieve details of all existing brands from table brand_types'
export const getBrandtype = async () => {
  try {
    const queryRoute = `/product/getBrandType`;

    const fetchRes = api.axios.post(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
export const updateProduct = async (data) => {
  try {
    const queryRoute = `/product/${data.id}`;

    const fetchRes = api.axios.patch(queryRoute, data);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const createProduct = async (newRow) => {
  try {
    const queryRoute = `/product`;

    const reqBody = { newRow: newRow };

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
export const createProductMonthlyDiscount = async (formData) => {
  try {
    const queryRoute = `/product/monthlyDiscount`;
    const reqBody = {
      data: formData,
    };
    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};
export const updateRebate = async (formData) => {
  try {
    const queryRoute = `/product/rebate`;
    const reqBody = {
      data: formData,
    };
    const fetchRes = api.axios.put(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};
export const updateProductMonthlyDiscount = async (formData, datetime) => {
  try {
    const queryRoute = `/product/updateMonthlyDiscount`;
    const reqBody = {
      data: formData,
      datetime,
    };
    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const getAllWorkLocationManage = async () => {
  try {
    const queryRoute = `/work/getAllWorkLocationManage`;

    const fetchRes = api.axios.post(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getAllAdmin = async () => {
  try {
    const queryRoute = `/work/getAllAdmin`;

    const fetchRes = api.axios.post(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getProductDiscount = async (
  startYear,
  endYear,
  productId,
  brand,
  region,
) => {
  try {
    const reqBody = { startYear, endYear, productId, brand, region };
    const queryRoute = `/product/discount?reqBody=${JSON.stringify(reqBody)}`;
    const fetchRes = api.axios.get(queryRoute);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getProductDiscountRemark = async (selectedYear) => {
  try {
    const queryRoute = `/product/discount/remark/${selectedYear}`;

    const fetchRes = api.axios.get(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const updateProductDiscountRemark = async (body) => {
  try {
    const queryRoute = `/product/discount/remark`;
    const reqBody = { ...body };
    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const createStockSheet = async (arrValue) => {
  try {
    const queryRoute = `/product/stockSheets`;
    const reqBody = { newValue: arrValue };
    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    throw err;
  }
};

export const fetchStockSheetTemplate = async (startDate, region, id) => {
  try {
    const queryRoute = `/product/stockSheetTemplate?info=${JSON.stringify({
      startDate: moment(startDate).format("YYYY-MM-DD"),
      region,
      id,
    })}`;

    const fetchRes = api.axios.get(queryRoute, {
      responseType: "blob",
    });

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};
